import { Helmet } from 'react-helmet-async';
import { useStoreInfo } from '@/lib/store';

export function PrivacyPolicyPage() {
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Privacy Policy${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Our privacy policy and data protection practices" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section className="space-y-4">
                <p>
                  This Privacy Policy describes how {storeInfo?.site_name || 'we'} ("we," "us," or "our") collects, uses, and shares your personal information when you visit our website.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Information We Collect</h2>
                <p>
                  When you visit our website, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">How We Use Your Information</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>To process your orders and provide customer service</li>
                  <li>To communicate with you about your orders and provide updates</li>
                  <li>To improve our website and customer experience</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Information Sharing</h2>
                <p>
                  We share your Personal Information with service providers to help us provide our services and fulfill our contracts with you. For example:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Payment processors for secure payment handling</li>
                  <li>Delivery services to fulfill your orders</li>
                  <li>Email service providers for order communications</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Your Rights</h2>
                <p>
                  You have the right to access, correct, or delete your personal information. Please contact us for any privacy-related concerns.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Contact Us</h2>
                <p>
                  For more information about our privacy practices, please contact us at {storeInfo?.contact_email || 'our contact email'}.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}